module.exports = {
      id: "breadcrumb-arrow-usage",
      viewBox: "0 0 5 5",
      url: __webpack_public_path__ + "images/sprites__hca--b09229b8f580b80e1c405e02b95f06c8.svg#breadcrumb-arrow-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./client/src/site__hca/sprites/breadcrumb-arrow.svg
// module id = D:\a\1\s\node_modules\svg-sprite-loader\lib\loader.js??ref--13-0!D:\a\1\s\client\src\site__hca\sprites\breadcrumb-arrow.svg
// module chunks = site__hca